<div class="sub-accounts">
  <div class="sub-accounts__title">Sub Accounts</div>
  <ag-grid-angular
    class="ag-theme-balham-dark sub-accounts__ag-grid"
    [columnDefs]="$any(columnDefs)"
    [rowSelection]="'single'"
    [singleClickEdit]="true"
    [defaultColDef]="defaultColDef"
    (selectionChanged)="onSelectionChanged()"
    (gridReady)="gridReady($event)"
  >
  </ag-grid-angular>

  <div class="sub-accounts__footer">
    <button
      type="button"
      class="ui-button ui-button__header ui-button--danger ui-button--delete sub-accounts__footer__delete-button"
      [disabled]="selectedAccount == null"
      (click)="deleteEntity()"
    >
      Delete
    </button>

    <button
      type="button"
      class="ui-button ui-button__header ui-button--primary"
      (click)="addNewEntity()"
    >
      Add Sub Account
    </button>
  </div>
</div>

<ng-template let-row="rowInfo" #inputComponent>
  <ng-container *ngIf="row?.rowData" [formGroup]="entitiesForm">
    <ng-container formArrayName="entities">
      <ng-container [formGroupName]="this.rowIndex">
        <ng-container formArrayName="subAccounts">
          <ng-container [formGroupName]="row.rowData.rowIndex">
            <input
              #checkbox
              clrCheckbox
              type="checkbox"
              [formControlName]="row.colId"
              (change)="updateRow(row.colId, checkbox.checked, row.rowId)"
            />
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
